import { AxiosPromise } from 'axios';
import { ContactStatus, CreateContactStatusRequest } from '../../types/ContactStatus';
import { libApiInstance } from '../axios';

export function requestUserContactStatuses(signal?: AbortSignal): AxiosPromise<ContactStatus[]> {
    return libApiInstance.get('/contacts/statuses', { signal });
}

export function requestCreateUserContactStatuses(
    data: CreateContactStatusRequest,
    signal?: AbortSignal,
): AxiosPromise<number> {
    return libApiInstance.post('/contacts/statuses', data, { signal });
}

export function requestDeleteUserContactStatuses(
    statusId: number,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.delete(`/contacts/statuses/${statusId}`, { signal });
}

export function requestUpdateUserContactStatuses(
    data: CreateContactStatusRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.put(`/contacts/statuses`, data, { signal });
}
